import { render, staticRenderFns } from "./StockSelect.vue?vue&type=template&id=0dfc3b50&"
import script from "./StockSelect.vue?vue&type=script&lang=js&"
export * from "./StockSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports